import { formatNumber } from 'src/utils/numbers';

export const calculateNumberOfPages = (total, perPage) => {
  let pages = parseInt(total / perPage);

  if (total % perPage > 0) {
    pages += 1;
  }

  return pages;
};

export const generatePageRangeHeader = ({ page, perPage, count, isLoading }) => {
  const pageStartNumber = (page - 1) * perPage + 1;
  const pageEndNumber = Math.min((page - 1) * perPage + perPage, count);
  const pageStartFormatted = formatNumber(pageStartNumber, { useGrouping: true });
  const pageEndFormatted = formatNumber(pageEndNumber, { useGrouping: true });

  if (isLoading || count === 0) {
    return ' 0 - 0 ';
  }

  return ` ${pageStartFormatted} - ${pageEndFormatted} `;
};